'use client';

import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { EmblaOptionsType } from 'embla-carousel';
import { NextButton, PrevButton, usePrevNextButtons } from './EmblaCarouselArrowButton';
import { DotButton, useDotButton } from './EmblaCarouselDotButton';
import TourCard from '../TourCard';
import './css/carousel.css';

import { TTour } from '@/types';

type PropType = {
  tours: Array<TTour>;
  options?: EmblaOptionsType;
  lazyLoadImages?: boolean;
  showNextArrow?: boolean;
  onTourClick?: (tour: TTour) => void;
};

export const TourCarousel: React.FC<PropType> = (props) => {
  const { tours, options, lazyLoadImages, showNextArrow, onTourClick } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi);

  return (
    <div className="embla mt-auto lg:-mt-12">
      <div className="embla__controls">
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      </div>

      <div className="embla__viewport-wrapper relative">
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container">
            {tours.map((tour) => (
              <TourCard
                tour={tour}
                key={tour.id}
                lazyLoadImages={lazyLoadImages}
                onClick={onTourClick ? () => onTourClick(tour) : undefined}
              />
            ))}
          </div>
        </div>
        {showNextArrow && !nextBtnDisabled && (
          <button
            type="button"
            onClick={onNextButtonClick}
            className="embla__next-arrow"
            aria-label="View next tour"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        )}
      </div>

      <div className="embla__dots">
        {scrollSnaps.map((_, index) => (
          <DotButton
            key={index}
            onClick={() => onDotButtonClick(index)}
            className={'embla__dot'.concat(index === selectedIndex ? ' embla__dot--selected' : '')}
          />
        ))}
      </div>
    </div>
  );
};

export default TourCarousel;
